import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import ContentLandingPageWrapper from '../Components/ContentLandingPageWrapper';
import Fonts from '../Styles/Fonts';
import Colors from '../Styles/Colors';

const Title = styled.h2`
    ${Fonts.decotura.medium}
    color: ${Colors.white};
    font-size: 19px;
`;
const EventListDayTitle = styled.h3`
    ${Fonts.merriweather.bold}
    color: ${Colors.white};
    font-size: 19px;
    background-color: ${Colors.grayDark};
    border-bottom: 1px solid ${Colors.goldDark};
    padding: 9px 16px 8px;
    margin: 0 0 16px;
`;
const EventListItemDetails = styled.div`
    margin-bottom: 18px;
    margin-left: 16px;
    line-height: 1;
    color: ${Colors.white};

`;
const EventListItemTime = styled.strong`
    margin-bottom: 5px;
    display: block;
    color: ${Colors.white};
`;
const EventListItemName = styled.div`
  white-space: pre-line;
  color: ${Colors.white};
`;

class EventInfoItineraryPage extends Component {
  componentDidMount = () => {
  };

  formatDateForDayDisplay = (date) => {
      const parsedDate = date.split('-');
      return parseInt(parsedDate[1]) + "/" + parseInt(parsedDate[2]) + "/" + parsedDate[0];
  }

  renderEventsList = () => {
      let previousDate = null;
      let eventsList = [];

      if (this.props.content && this.props.content.events && this.props.content.events.length > 0) {
          this.props.content.events.forEach((event, index) => {
            const parsedDate = Date.parse(event.date);
            if (parsedDate !== previousDate) {
                eventsList.push((
                    <EventListDayTitle key={`day-${index}`}>{ this.formatDateForDayDisplay(event.date) }</EventListDayTitle>
                ));
                previousDate = parsedDate;
            }
            
            eventsList.push((
                <EventListItemDetails key={index}>
                    <EventListItemTime>{ event.time.processed }</EventListItemTime>
                    <EventListItemName>{ event.name.processed }</EventListItemName>
                </EventListItemDetails>
            ))
          });

          return eventsList;
      } else {
          return null;
      }
  };

  render() {
    return (
      <ContentLandingPageWrapper headerTitle="Event Info" headerSubtitle="Itinerary" fullWidth={true}>
        <Title dangerouslySetInnerHTML={{ __html: this.props.content.title}}></Title>
        { this.renderEventsList() }
      </ContentLandingPageWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      content: state.content.eventInfoItineraryContent
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      performDispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventInfoItineraryPage);